import { render, staticRenderFns } from "./AdditionalInfoRight.vue?vue&type=template&id=bf665cf4&scoped=true&"
import script from "./AdditionalInfoRight.vue?vue&type=script&lang=js&"
export * from "./AdditionalInfoRight.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalInfoRight.vue?vue&type=style&index=0&id=bf665cf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf665cf4",
  null
  
)

export default component.exports